// Default dto values for existing and future control results paginated list dtos
export const defaultPaginatedListDto = {
    pagination: { prev: null, next: null },
    content: [],
    linkedResources: {
        controlPrograms: [],
        controls: [],
        users: [],
        controlResultUserPools: [],
        entities: [],
        classification: null,
    },
};
